import React from "react"
import PropTypes from "prop-types"
import TextVideoFrame from "components/text-video-frame"
import LocationText from "components/location-text"
import TimeClockVideoFrameBlock from "blocks/time-clock-video-frame"

const dayOfTheWeek = () => {
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  return days[new Date().getDay()]
}

const renderDynamicText = ({ type, text }) => {
  switch (type) {
  case "Location":
    return <LocationText fallbackText={text} />
  case "Day":
    return dayOfTheWeek()
  case "Text":
    return text
  case "Time":
    return <TimeClockVideoFrameBlock />
  default:
    return null
  }
}

const DynamicTextVideoFrameBlock = props => (
  <TextVideoFrame>
    <span style={{ fontFamily: "dseg7", fontSize: 0, position: "absolute" }}>.</span>
    {renderDynamicText(props)}
  </TextVideoFrame>
)

renderDynamicText.propTypes = {
  type: PropTypes.oneOf(["Location", "Day", "Text"]),
  text: PropTypes.string
}

export default DynamicTextVideoFrameBlock



// WEBPACK FOOTER //
// ./src/blocks/dynamic-text-video-frame/index.jsx